import {
  COMPREHENCIVE_QUOTE_DATA,
  COMPREHENCIVE_QUOTE_DATA_BY_ID,
  QUOTE_CONFIGURATION_SUCCESS,
  CLEAR_QUOTE_CONFIGURATION,
} from '../../actions/CPQ/ActionTypes';
import { FETCH_START, FETCH_END } from '../../actions/Pricing/ActionTypes';

const initialState = {
  loading: false,
  comprehensiveQuoteData: [],
  comprehensiveQuoteSingleData: {},
  quoteConfigurationData: [],
};

const CPQReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return { ...state, loading: true };
    case FETCH_END:
      return { ...state, loading: false };
    case COMPREHENCIVE_QUOTE_DATA:
      return { ...state, comprehensiveQuoteData: action.data, loading: false };
    case COMPREHENCIVE_QUOTE_DATA_BY_ID:
      return { ...state, comprehensiveQuoteSingleData: action.data, loading: false };
    case QUOTE_CONFIGURATION_SUCCESS:
      return { ...state, quoteConfigurationData: action.data, loading: false };
    case CLEAR_QUOTE_CONFIGURATION:
      return { ...state, quoteConfigurationData: [], loading: false };
    default:
      return state;
  }
};

export default CPQReducer;
